import { useState } from 'react';

// Material UI imports
import { Divider, Box, Tabs, Tab, makeStyles } from '@material-ui/core';

// Style
import styles from './styles';
import './styles.scss';

const useStyles = makeStyles(styles);

function TabPanel(props) {
  const { children, display, view } = props;

  return (
    <Box
      style={{
        display: display ? 'flex' : 'none',
        flexDirection: view ? 'row' : 'column',
        flexWrap: view ? 'wrap' : 'unset',
        flexGrow: 1
      }}>
      {children}
    </Box>
  );
}

function TabContainer(props) {
  // Grab the tabs from the component's props
  // Support both onChange and onTabChange for backward compatibility
  const { className, tabs, initial, index, onChange, onTabChange, view } =
    props;
  const classes = useStyles();

  // Use onTabChange if provided, otherwise fall back to onChange
  const handleTabChange = onChange || onTabChange;

  // Initialize the container's state
  const [tabIndex, updateTabIndex] = useState(initial || 0);

  // Tab change handler
  const handleChange = (event, newValue) => {
    if (index !== null && index !== undefined && handleTabChange) {
      handleTabChange(newValue);
    } else {
      updateTabIndex(newValue);
      handleTabChange && handleTabChange(newValue);
    }
  };

  // Props generator
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  };

  // Make sure our tab data is an array
  if (Array.isArray(tabs)) {
    return (
      <div className={`${classes.root} ${className}`}>
        <Tabs
          className="booking-tabs"
          value={index || tabIndex}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="simple tabs example">
          {tabs.map((tab, index) => (
            <Tab
              disableRipple
              key={tab.label}
              label={tab.label.toUpperCase()}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
        <Divider className={classes.divider} />
        {tabs.map((tab, mapIndex) => {
          if ((index || tabIndex) === mapIndex) {
            return (
              <TabPanel view={view} key={`${tab.label}-panel`} display={true}>
                {tab.component}
              </TabPanel>
            );
          }
          return null;
        })}
      </div>
    );
  }

  return null;
}

export default TabContainer;
